// import { opentracing, stalk } from 'stalk-opentracing';
import { opentracing, stalk } from '@/lib/stalk-opentracing/dist/web';
import { store } from 'Store/store.index';
import { browserVersion } from '../utils/browser-info';
import cuid from 'cuid';
import { storageGetItem, storageSetItem, getProductNameForDashboard } from '@/utils/utils';
// import md5 from 'crypto-js/md5';
import { getPlatform } from "./utils/Api.utils";
let reportPromise = Promise.resolve();
export default class JaegerApi {
  constructor() {
    this.jaegerReporter = null;
    this.globalTracer = null;
    this.RequestSignature = 'eSignRequestSignatures';
    this.AgreementStatus = 'eSignAgreementStatus';
  }
  getFoxitSignInfo() {
    return new Promise((resolve) => {
      const flag = setInterval(() => {
        const { foxitSignInfo } = store.userStore;

        if (foxitSignInfo) {
          clearInterval(flag);
          resolve();
        }
      }, 0);
    });
  }
  async getJaegerData({
    uuid,
    userID,
    operationName,
    category,
    osLang,
    osVersion,
    userAgent,
    productName,
    productLang,
    productVersion,
    productType,
    extraInformation,
    moreInfo,
  }) {
    if (operationName === this.RequestSignature || operationName === this.AgreementStatus) {
      return {
        productName,
        productLang,
        productVersion: '1.0',
        productType,
        userID,
        operationName,
        category,
        extraInformation: JSON.stringify({
          appName: 'Phantom Online',
          appVersion: productVersion,
          appType: await this.getProductType('Phantom Online'),
          userAgent: userAgent,
        }),
        osLang,
        osVersion,
        uuid,
      };
    }

    let jaegerData = {
      uuid,
      userID,
      operationName,
      category,
      osLang,
      osVersion,
      productName,
      productLang,
      productVersion,
      productType,
    };

    if (extraInformation) {
      let extraInformation1 = {
        ...extraInformation,
        userAgent: userAgent,
      }
      jaegerData = {
        ...jaegerData,
        extraInformation: JSON.stringify(extraInformation1),
      };
    } else {
      let extraInformation1 = {
        userAgent: userAgent,
      }
      jaegerData = {
        ...jaegerData,
        extraInformation: JSON.stringify(extraInformation1),
      };
    }
    if (moreInfo) {
      jaegerData = {
        ...jaegerData,
        ...moreInfo,
      };
    }

    return jaegerData;
  }
  async getProductType(operationName) {
    // TODO: get foxit sign product type
    if (operationName === this.RequestSignature || operationName === this.AgreementStatus) {
      let result = '';
      let { foxitSignInfo } = store.userStore;

      if (!foxitSignInfo) {
        await this.getFoxitSignInfo();
      }

      const {
        foxitSignInfo: { subscribe_type, subscribe_status },
      } = store.userStore;

      if (subscribe_type === 1 && (subscribe_status === 1 || subscribe_status === 2)) {
        result = 'SS';
      }
      if (subscribe_type === 1 && (subscribe_status === 3 || subscribe_status === 4)) {
        result = 'ST';
      }
      if (subscribe_type === 2 && (subscribe_status === 1 || subscribe_status === 2)) {
        result = 'ES';
      }
      if (subscribe_type === 2 && (subscribe_status === 3 || subscribe_status === 4)) {
        result = 'ET';
      }

      return result;
    }

    return store.accountStore.getSubscribeType();
  }
  getProductName(operationName) {
    if (operationName === this.RequestSignature || operationName === this.AgreementStatus) {
      return 'Foxit Sign';
    }

    return getProductNameForDashboard();
  }
  initJaeger(jaegerBaseUrl) {
    if (!jaegerBaseUrl) {
      return;
    }

    // const jaegerBaseUrl = store.appStore.phantomOnlineGlobalConfig.jaegerBaseUrl;
    const stalkTracer = new stalk.Tracer();
    const jaegerReporter = new stalk.reporters.JaegerReporter({
      // Jaeger collector base url
      jaegerBaseUrl,

      process: {
        serviceName: 'Template',
      },

      // If you're on browsers, pass this: window.fetch.bind(window)
      fetch: window.fetch.bind(window),

      // Extra http headers, like basic authentication
      // requestHeaders: {},
    });

    stalkTracer.addReporter(jaegerReporter);
    opentracing.initGlobalTracer(stalkTracer);

    this.jaegerReporter = jaegerReporter;
    this.globalTracer = opentracing.globalTracer();
  }
  async sendJaegerData({ extraInformation, category: jaegerCategory,eventKey }) {
 
    if (!this.jaegerReporter) {
      return;
    }

    let jaegerData;
    // let userID = '';
    const span = this.globalTracer.startSpan(eventKey);
    // const { full: language } = store.appStore.lng;
    const userAgent = window.navigator.userAgent;
    const { userInfo,disableTrace } = store.appStore;
    if(disableTrace){
      return
    }
    // if (userInfo) {
    //   if (operationName === this.RequestSignature || operationName === this.AgreementStatus) {
    //     userID = md5(userInfo.cUserID).toString();
    //   } else {
    //     userID = userInfo.cUserID
    //   }
    // }
    let uuid;
    if(userInfo && userInfo.uuid){
      uuid = userInfo.uuid
    }else{
      uuid = storageGetItem(localStorage, 'uuidForJaeger');
      if (!uuid) {
        uuid = cuid();
        storageSetItem(localStorage, 'uuidForJaeger', uuid);
      }
    }
    let osVersion = browserVersion;

    if (!osVersion) {
      osVersion = userAgent;
    }
    const {platform} = getPlatform();
    extraInformation.uuid = uuid;
    jaegerData = {
      productName:"Template",
      operationName:eventKey,
      extraInformation: JSON.stringify(extraInformation),
      category:jaegerCategory,
      uuid,
      userID:userInfo.userid? userInfo.userid: '',
      osVersion,
      platform
    }
    // jaegerData = await this.getJaegerData({
    //   uuid,
    //   userID,
    //   operationName,
    //   category,
    //   // osLang: language,
    //   osVersion: osVersion,
    //   userAgent: userAgent,
    //   productName: this.getProductName(operationName),
    //   // productLang: language,
    //   productVersion: '2.0.0.0',
    //   productType: await this.getProductType(operationName),
    //   extraInformation,
    //   moreInfo,
    // });
    // add base data
    span.addTags(jaegerData);
    span.finish();
    reportPromise = reportPromise
      .then(() => this.jaegerReporter.report())
      .catch((error) => {
        console.error('===>>> ~ JaegerApi ~ sendJaegerData ~ error', error);
      });
  }
}
